<template>
    <div v-if="consent && isShow" class="modal-cookie-consent">
        <div class="title">{{ data.title }}</div>
        <div class="detail" v-html="data.detail"></div>
        <a class="btn-accept" @click="closeConsent">{{ data.accept }}</a>
    </div>
</template>

<script>
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
import Vue from "vue";

export default {
    data: function() {
        return {
            consent: true,
            isShow: true,
            data: {}
        };
    },
    created() {
        this.getConfig();
        this.checkConcent();
    },
    methods: {
        checkConcent() {
            if (Vue.$cookies.get("checkConsent")) {
                this.consent = false;
            }
        },
        getConfig() {
            return new Promise(resolve => {
                BzbsCustom.apiGetCustom(
                    "/nestle/nescafe_streetcafe/custom/nescafe_streetcafe_content.json"
                )
                    .then(response => {
                        this.isShow = response.consent.isShow;
                        this.data = response.consent;
                        // console.log(this.data)
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                        resolve(error);
                    });
            });
        },
        closeConsent() {
            this.consent = false;
            Vue.$cookies.set("checkConsent", true);
        }
    }
};
</script>

<style lang="scss">
.modal-cookie-consent {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 555;
    width: 100%;
    background: #eeeeee;
    padding: 20px 35px 26px;
    font-size: 22px;
    text-align: left;
    color: #444;
    font-size: 18px;
    .title {
        color: #5b5b5b;
        margin-bottom: 5px;
    }
    .detail {
        color: #7e7e7e;
        margin-bottom: 6px;
        line-height: normal;
        letter-spacing: normal;
        span {
            color: #007cba;
        }
        .blue {
            color: #007cba;
        }
    }

    .btn-accept {
        display: block;
        border-radius: 5px;
        border: solid 1px #65513e;
        background-color: #fff;
        color: #65513e;
        text-align: center;
        height: 35px;
        line-height: 33px;
    }
}
</style>
